import { render, staticRenderFns } from "./recordIncomingProducts.vue?vue&type=template&id=08815426&scoped=true"
import script from "./recordIncomingProducts.vue?vue&type=script&lang=js"
export * from "./recordIncomingProducts.vue?vue&type=script&lang=js"
import style0 from "./recordIncomingProducts.vue?vue&type=style&index=0&id=08815426&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08815426",
  null
  
)

export default component.exports